import { ImportCSV } from "./importCSV.interface";

export interface ImportEdiOrdersCSV extends ImportCSV {
	clientId: number;
	orderReference: string;
}

export class ImportEdiOrdersCSV implements ImportEdiOrdersCSV {	
	constructor(data?: Partial<ImportEdiOrdersCSV>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}